import React from 'react';
import { FaExclamation } from 'react-icons/fa';

const SessionLobbyButton = ({
  children,
  isPermitted,
  isEnabled,
  onClick,
  title,
}: {
  children: React.ReactNode;
  isEnabled: boolean;
  isPermitted: boolean;
  onClick: () => void;
  title: string;
}) => {
  // rendering session lobby button component here
  return (
    <div>
      <button
        title={title}
        type='button'
        onClick={onClick}
        className={`relative flex items-center justify-center text-base-white size-[30px] md:size-[50px] rounded-full hover:scale-110 active:scale-95 duration-300 ${
          isEnabled ? 'bg-base-purple' : 'bg-base-red'
        } ${!isPermitted ? 'bg-base-red' : ''}`}
      >
        {children}

        {!isPermitted ? (
          <div className='absolute flex items-center justify-center -top-1 -right-1 size-5 rounded-full bg-base-orange'>
            <FaExclamation className='text-legal-dark-blue size-3' />
          </div>
        ) : null}
      </button>
    </div>
  );
};

export default SessionLobbyButton;
